export default {
  myWork_no_homework: 'No assignment yet',
  myWork_homework_list: '0407Web-Show my homework list',
}
